import {
  buildWidget,
  getBottomComponentHtml,
} from './table-view';

require('./fact-widget.component.scss');

function str2ab(str) {
  const buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
  const bufView = new Uint16Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

export function FactsWidgetComponent($compile) {
  return {
    restrict: 'E',
    scope: {
      model: '<',
      filter: '<',
      fact: '<',
      openImage: '<',
      listType: '<',
    },
    controller: function(
      $scope,
      $element,
      LocalStorageService,
      FilterResource,
    ) {
      $scope.FilterResource = FilterResource;
      $scope.isCollapsed = $scope.listType === 'full';
      $scope.loading = true;

      $scope.collapse = function() {
        $scope.isCollapsed = !$scope.isCollapsed;
        if ($scope.isCollapsed) {
          $element.addClass('collapsed');
        } else {
          if (!$scope.fact['complete_data']) {
            $scope.loading = true;
            $scope.FilterResource.getCompleteFact($scope.filter, $scope.fact.id)
              .then(data => {
                if (data && $scope.fact.id == data.id) {
                  Object.assign($scope.fact, data);
                  const widget = buildWidget($scope.fact);
                  $element.html(widget);
                  $compile($element.contents())($scope);
                }
                $scope.loading = false;
              });
          }
          $element.removeClass('collapsed');
        }
      };
      $scope.collapse();

      $scope.copyToClippboard = (e, text) => {
        e.stopPropagation();
        if (!text) {
          const text = e.target.closest('.widget-value').innerText;
        }
        LocalStorageService.copyTextToClipboard(text);
      };

    },
    link: function(scope, element, attrs) {
      if (!scope.openImage) {
        scope.openImage = () => {};
      }
      scope.loading = false;
      const widget = '<sc-spinner ng-if="loading" style="z-index: 999;"></sc-spinner>' + buildWidget(scope.fact);
      element.append(widget);
      $compile(element.contents())(scope);
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/fact-widget.component.js